export default "__VITE_ASSET__CN5wUL1l__"